/**
 *
 */

var Menu = (function($) {
  function initMenu() {
    $("body").toggleClass("has-nav");
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header-nav").length) {
      return;
    }

    $(".hamburger").click(function() {
      initMenu();
    });

    $(document).on("click", ".header-menu__item a", function() {
      if ($(window).width() <= 900) {
        $("body").removeClass("has-nav");
      }
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
